<div class="relative p-6 font-roboto w-full bg-transparent min-h-[250px]">
  <!-- --- HEADER --- -->
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center text-[#2b6cb0] font-bold text-sm">
      <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
          clip-rule="evenodd" transform="rotate(180 10 10)"></path>
      </svg>
      Payment
    </div>
    <button (click)="goBack()"
      class="flex items-center cursor-pointer mt-2 gap-1.5 px-3 py-1.5 bg-white border border-gray-200 rounded text-gray-600 text-xs font-medium hover:bg-gray-50 hover:text-[#2b6cb0] hover:border-[#2b6cb0] transition-all shadow-sm">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
      </svg>
      Back
    </button>
  </div>

  <!-- --- CARDS GRID --- -->
  <div class="flex flex-col lg:flex-row gap-4">
    <div *ngFor="let card of cards" (click)="openPopup(card)" [style.background-color]="card.outerBg"
      class="rounded-xl p-2 shadow-sm min-w-[280px] flex-1 border border-black/5 hover:shadow-md hover:-translate-y-1 transition-all duration-300 cursor-pointer group">
      <div class="flex items-center justify-center py-2 mb-1">
        <img [src]="card.iconUrl" alt="icon"
          class="w-5 h-5 mr-2 object-contain drop-shadow-sm group-hover:scale-110 transition-transform">
        <span class="font-bold text-gray-800 text-sm tracking-wide uppercase">{{ card.title }}</span>
      </div>
      <div [style.background-color]="card.innerBg" class="rounded-lg p-3 shadow-inner border border-black/5">
        <div class="space-y-[6px]">
          <div *ngFor="let row of card.rows"
            class="grid grid-cols-[1fr_auto_1fr] items-baseline text-[11px] font-medium leading-tight">
            <div class="text-gray-900 truncate pr-1">{{ row.label }}</div>
            <div class="px-2 text-gray-600">:</div>
            <div class="text-right flex justify-end items-center whitespace-nowrap">
              <span
                [ngClass]="{'text-red-600 font-bold': row.color === 'red', 'text-green-500 font-bold': row.color === 'green', 'text-gray-900 font-bold': row.color === 'black'}">{{
                row.val }}</span>
              <span *ngIf="row.unit" class="ml-1 text-gray-500">{{ row.unit }}</span>
              <span *ngIf="row.suffix" [class]="row.suffixColor + ' text-[10px] ml-1 font-bold'">{{ row.suffix }}</span>
            </div>
          </div>
        </div>
        <div class="my-2 border-t border-gray-300/40"></div>
        <div class="grid grid-cols-[1fr_auto_1fr] items-baseline text-[11px] font-bold">
          <div class="text-gray-800 uppercase">{{ card.balanceLabel }}</div>
          <div class="px-2 text-gray-600">:</div>
          <div class="text-right flex justify-end items-center whitespace-nowrap">
            <span class="text-gray-900">{{ card.balanceVal }}</span>
            <span class="text-gray-900 ml-1">{{ card.balanceUnit }}</span>
            <span [ngClass]="card.balanceSuffix === 'DR' ? 'text-red-500' : 'text-green-500'" class="ml-1">{{
              card.balanceSuffix }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- --- POPUP MODAL --- -->
  <div *ngIf="selectedCard"
    class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4 animate-fadeIn">
    <div (click)="$event.stopPropagation()"
      class="bg-white rounded-lg shadow-2xl w-full max-w-[1450px] overflow-hidden flex flex-col max-h-[92vh] border border-gray-100">

      <!-- Header -->
      <div class="bg-white px-5 py-3 border-b flex justify-between items-center shadow-sm z-10">
        <div class="flex items-center gap-2">
          <div
            class="w-7 h-7 bg-yellow-50 rounded-md border border-yellow-100 flex items-center justify-center shadow-sm">
            <img src="assets/images/rate-cut-no-rate-cut/Rate-cut-no-rate-cut.png" class="w-4 h-4 object-contain"
              alt="icon">
          </div>
          <h2 class="font-bold text-gray-800 text-sm tracking-wide uppercase">No Rate Cut / Rate Cut Panel</h2>
        </div>
        <button (click)="closePopup()"
          class="text-gray-400 hover:text-red-500 hover:bg-red-50 p-1 rounded-full transition-all">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>


      <!-- Table Container (Existing Functionality Preserved) -->
      <div class="overflow-auto flex-1 p-5 bg-white min-h-[400px]">
        <!-- ================= BALANCE SNAPSHOT TABLE (DESIGN MATCHED) ================= -->
        <div class="mb-6 border-2 border-gray-500 rounded-lg overflow-hidden shadow-sm">

          <table class="w-full border-collapse font-roboto">
            <colgroup>
              <col style="width:160px">
              <col style="width:140px">
              <col style="width:110px">
              <col style="width:120px">
              <col style="width:150px">
              <col style="width:100px">
              <col style="width:120px">
              <col style="width:150px">
              <col style="width:130px">
              <col style="width:130px">
              <col style="width:150px">
            </colgroup>

            <!-- HEADER -->
            <thead>
              <tr class="bg-[#F4B084] text-black font-bold uppercase text-[13px]">
                <th class="px-4 py-3 border border-gray-500 text-left">Transaction</th>
                <th class="px-4 py-3 border border-gray-500 text-left">Metal / Currency</th>
                <th class="px-4 py-3 border border-gray-500 text-left">Category</th>
                <th class="px-4 py-3 border border-gray-500 text-left">Name</th>
                <th class="px-4 py-3 border border-gray-500 text-right">Gs Wt</th>
                <th class="px-4 py-3 border border-gray-500 text-center">Purity</th>
                <th class="px-4 py-3 border border-gray-500 text-right">Fine Wt</th>
                <th class="px-4 py-3 border border-gray-500 text-right">Metal ↔ Amt</th>
                <th class="px-4 py-3 border border-gray-500 text-right">Rate(₹ / GM)</th>
                <th class="px-4 py-3 border border-gray-500 text-right">Amount</th>
                <th class="px-4 py-3 border border-gray-500 text-right">Final Balance</th>
              </tr>
            </thead>

            <!-- BALANCE ROWS -->
            <tbody>
              <tr *ngFor="let r of readonlySnapshotRows"
                class="bg-[#FCE4D6] text-[14px] font-semibold pointer-events-none">

                <!-- Transaction -->
                <td class="px-4 py-3 border border-gray-400 font-bold">
                  Balance
                </td>

                <!-- Metal / Currency -->
                <td class="px-4 py-3 border border-gray-400 font-bold"
                  [ngClass]="r.metal === 'AMT' ? 'bg-[#BEEBFD]' : 'bg-[#FFC000]'">
                  {{ r.metal }}
                </td>

                <td class="px-4 py-3 border border-gray-400">—</td>
                <td class="px-4 py-3 border border-gray-400">—</td>

                <!-- Previous Balance (shown in Gs Wt) -->
                <td class="px-4 py-3 border border-gray-400 text-right">
                  {{ r.opening }}
                </td>

                <!-- Purity -->
                <td class="px-4 py-3 border border-gray-400 text-center">
                  —
                </td>

                <!-- Current Sold (shown in Fine Wt) -->
                <td class="px-4 py-3 border border-gray-400 text-right font-bold">
                  {{ r.sold }}
                </td>

                <!-- Physical Metal Received (shown in Metal <-> Amt) -->
                <td class="px-4 py-3 border border-gray-400 text-right">
                  {{ r.received }}
                </td>
                <td class="px-4 py-3 border border-gray-400 text-right">—</td>
                <td class="px-4 py-3 border border-gray-400 text-right">—</td>

                <!-- Final Balance -->
                <td class="px-4 py-3 border border-gray-400 text-right font-bold"
                  [ngClass]="r.balanceType === 'DR' ? 'text-red-600' : 'text-green-600'">
                  {{ r.balance }}
                  <span class="text-[11px] ml-1">{{ r.balanceType }}</span>
                </td>
              </tr>
            </tbody>


          </table>
        </div>
        <!-- ================= END BALANCE SNAPSHOT ================= -->

        <table class="w-full text-sm border-collapse border border-gray-400">
          <!-- <thead>
          <tr class="bg-[#F4B084] text-black font-bold border border-gray-400 shadow-sm uppercase text-[10px] tracking-wider">
            <th class="py-2.5 px-3 border border-gray-400 text-left">Transaction</th>
            <th class="py-2.5 px-3 border border-gray-400 text-left">Metal/Currency</th>
            <th class="py-2.5 px-3 border border-gray-400 text-left">Category</th>
            <th class="py-2.5 px-3 border border-gray-400 text-left">Name</th>
            <th class="py-2.5 px-3 border border-gray-400 text-right">Gs Wt</th>
            <th class="py-2.5 px-3 border border-gray-400 text-center">Purity</th>
            <th class="py-2.5 px-3 border border-gray-400 text-right">Fine Wt</th>
            <th class="py-2.5 px-3 border border-gray-400 text-right">Metal <-> Amt</th>
            <th class="py-2.5 px-3 border border-gray-400 text-right">Rate</th>
            <th class="py-2.5 px-3 border border-gray-400 text-right">Amount</th>
            <th class="py-2.5 px-3 border border-gray-400 text-right">Final Balance</th>
          </tr>
        </thead> -->
          <colgroup>
            <col style="width:160px">
            <col style="width:140px">
            <col style="width:110px">
            <col style="width:120px">
            <col style="width:150px">
            <col style="width:100px">
            <col style="width:120px">
            <col style="width:150px">
            <col style="width:130px">
            <col style="width:130px">
            <col style="width:150px">
          </colgroup>
          <tbody>
            <tr *ngFor="let row of tableData; let i = index" class="border border-gray-400 h-10 transition-colors"
              [ngClass]="row.isBalanceRow ? 'bg-[#FCE4D6]' : 'bg-white'">

              <td class="px-3 border border-gray-400 relative font-medium">
                <div (click)="toggleTransactionDropdown(i, $event)"
                  class="cursor-pointer select-none flex items-center justify-between w-full px-2.5 py-1.5 rounded border font-bold text-[10px] uppercase shadow-sm"
                  [ngClass]="getTransactionClass(row.transaction)">
                  {{ row.transaction }}
                  <svg class="w-3 h-3 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </div>
                <div *ngIf="activeTransactionRowIndex === i"
                  class="absolute top-[85%] left-3 w-44 bg-white border border-gray-300 rounded shadow-2xl z-[200] overflow-hidden animate-dropdownIn">
                  <div *ngFor="let opt of transactionOptions" (click)="selectTransaction(row, opt)"
                    class="px-3 py-2 text-[11px] font-bold text-gray-600 cursor-pointer border-b border-gray-50 last:border-0 flex items-center gap-2 hover:bg-blue-50">
                    <span class="w-1.5 h-1.5 rounded-full"
                      [ngClass]="{'bg-blue-500': opt === 'Balance', 'bg-green-500': opt === 'Receive', 'bg-red-500': opt === 'Pay'}"></span>
                    {{ opt }}
                  </div>
                </div>
              </td>

              <!-- Metal/Currency: Mustard Gold for Metal, Light Blue for Amount -->
              <td class="px-2 border border-gray-400 relative"
                [ngClass]="row.currencyMode !== 'AMT' ? 'bg-[#FFC107]' : 'bg-[#BEEBFD]'">
                <ng-container *ngIf="row.isMetalDropdown; else staticMetal">
                  <div (click)="toggleMetalDropdown(i, $event)"
                    class="w-full text-black font-bold px-3 py-1.5 rounded-[3px] text-xs flex justify-between items-center cursor-pointer shadow-sm active:scale-[0.98] transition-all">
                    <span>{{ row.currencyMode === 'AMT' ? 'Amount' : row.metal }}</span>
                    <svg class="w-3 h-3 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </div>
                  <div *ngIf="activeMetalDropdownIndex === i"
                    class="absolute top-[calc(100%+4px)] left-0 w-full bg-white border border-gray-200 rounded shadow-xl z-50 overflow-hidden">
                    <div *ngFor="let opt of metalOptions" (click)="selectMetal(row, opt)"
                      class="px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-0 transition-colors flex items-center">
                      <span class="w-2 h-2 rounded-full mr-2"
                        [ngClass]="{'bg-amber-500': opt === 'Gold', 'bg-gray-400': opt === 'Silver', 'bg-blue-400': opt === 'AMT'}"></span>
                      {{ opt }}
                    </div>
                  </div>
                </ng-container>
                <ng-template #staticMetal>
                  <span class="text-black font-bold px-3 py-1.5 text-xs"> {{ row.metal }} </span>
                </ng-template>
              </td>

              <td class="px-3 border border-gray-400 text-gray-600">{{ row.category }}</td>
              <td class="px-3 border border-gray-400 text-gray-600">{{ row.name }}</td>

              <!-- Gs Wt (Permanent Underline + CR/DR color) -->
              <td class="px-2 border border-gray-400 text-right font-bold font-mono w-[150px]">
                <div class="flex items-center justify-end">
                  <input type="text" [(ngModel)]="row.gsWt" placeholder="0.00" appEnterToNext
                    (ngModelChange)="recalculateLedger()" (blur)="formatInputOnBlur(row, 'gsWt')"
                    class="w-[85px] bg-transparent !border-0 !border-b-2 !border-black text-right outline-none p-0 focus:ring-0">
                  <span *ngIf="row.gsWt" class="text-[9px] font-bold uppercase ml-1"
                    [ngClass]="row.finalBalanceType === 'DR' ? 'text-red-600' : 'text-green-600'">
                    {{ row.finalBalanceType }}
                  </span>
                </div>
              </td>

              <!-- Purity Editable -->
              <td class="px-2 border border-gray-400 text-center font-bold font-mono w-[100px]">
                <input type="text" [(ngModel)]="row.purity" appEnterToNext (ngModelChange)="recalculateLedger()"
                  class="w-full bg-transparent text-center outline-none border-none p-0 focus:ring-0 text-gray-800"
                  placeholder="100" />
              </td>

              <td class="px-4 border border-gray-400 text-right text-gray-600 font-bold"> {{ displayValue(row.fineWt) }}
              </td>

              <td class="px-3 border border-gray-400 text-right font-mono w-[150px]">
                <input type="text" [(ngModel)]="row.metalAmt" appEnterToNext placeholder="–"
                  (blur)="formatInputOnBlur(row, 'metalAmt')"
                  (ngModelChange)="recalculateLedger(); addNextRowIfNeeded(i)" [disabled]="row.isBalanceRow"
                  class="w-full bg-transparent text-right text-gray-800 font-bold outline-none border-none p-0 focus:ring-0">
              </td>

              <!-- Rate Column: Underline only for AMT mode -->
              <td class="px-3 border border-gray-400 text-right font-mono w-[130px]">
                <ng-container *ngIf="row.isBalanceRow || row.transaction === 'Pay'; else rateInput"><span
                    class="text-gray-300 text-right block w-full">—</span></ng-container>
                <ng-template #rateInput>
                  <input type="text" [(ngModel)]="row.rate" placeholder="0.00" appEnterToNext
                    (ngModelChange)="recalculateLedger()" (blur)="formatInputOnBlur(row, 'rate')"
                    [ngClass]="row.currencyMode === 'AMT' ? '!border-b-2 !border-black' : ''"
                    class="w-full bg-transparent !border-0 text-right font-bold outline-none p-0">
                </ng-template>
              </td>

              <!-- Amount Column: Underline only for AMT mode -->
              <td class="px-3 border border-gray-400 text-right font-mono w-[130px]">
                <ng-container *ngIf="row.isBalanceRow || row.transaction === 'Pay'; else amtInput"><span
                    class="text-gray-300 text-right block w-full">—</span></ng-container>
                <ng-template #amtInput>
                  <div class="flex justify-end">
                    <input type="text" [(ngModel)]="row.amount" placeholder="0.00" appEnterToNext
                      (ngModelChange)="recalculateLedger()" (blur)="formatInputOnBlur(row, 'amount')"
                      class="w-[85px] bg-transparent !border-0 text-right font-bold outline-none p-0">
                  </div>
                </ng-template>
              </td>

              <!-- Final Balance: Red for DR, Green for CR -->
              <td class="px-3 border border-gray-400 text-right font-bold font-mono text-md"
                [ngClass]="row.transaction === 'Balance' ? 'bg-[#FFFF00]' : 'bg-[#C6EFCE]'">
                <div *ngIf="row.finalBalance && row.finalBalance !== '0.00'"
                  class="flex items-center justify-end gap-1">
                  <span class="text-slate-900">{{ displayValue(row.finalBalance) }}</span>
                  <span class="text-[9px] px-1.5 py-0.5 rounded text-white font-bold uppercase shadow-sm"
                    [ngClass]="row.finalBalanceType === 'DR' ? 'bg-red-500' : 'bg-green-600'">
                    {{ row.finalBalanceType }}
                  </span>
                </div>
                <span *ngIf="!row.finalBalance || row.finalBalance === '0.00'" class="text-gray-300">—</span>
              </td>
            </tr>
            <!-- Invisible padding row -->
            <tr class="h-32 border-none">
              <td colspan="11" class="border-none"></td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="bg-gray-100 border-t-2 border-gray-400 font-bold h-10 shadow-inner">
              <td colspan="7"
                class="px-3 border border-gray-400 text-right text-gray-500 uppercase text-[10px] tracking-widest">
                Ledger Totals</td>
              <td class="px-3 border border-gray-400 text-right font-mono text-blue-900 bg-[#E2EFDA]"> {{ totalMetalAmt
                ? (totalMetalAmt | number:'1.2-2') : '0.00' }} </td>
              <td class="px-3 border border-gray-400 text-center text-gray-400">—</td>
              <td class="px-3 border border-gray-400 text-right font-mono text-emerald-900 bg-[#E2EFDA]"> {{ totalAmount
                ? (totalAmount | number:'1.2-2') : '0.00' }} </td>
              <td class="px-3 border border-gray-400 bg-white"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Footer Action -->
      <div class="p-5 bg-gray-50 border-t border-gray-200 flex justify-center">
        <button (click)="onSubmitRateCut()"
          class="bg-[#198754] hover:bg-[#157347] text-white font-bold py-2.5 px-20 rounded shadow-md transition-all text-sm uppercase tracking-widest active:scale-95">
          Submit Settlement
        </button>
      </div>

    </div>
  </div>
</div>